<div class="modal-content">

  <div class="modal-header">
    <div class="header-left">
      <div class="title">Select File Type</div>
      <div class="subtitle">Choose Excel or JSON</div>
    </div>

    <mat-icon mat-dialog-close class="close-button" *ngIf="!isUploading">close</mat-icon>
  </div>

  <div class="content">

    <div class="file-type-container" [class.disabled]="isUploading">

      <!-- Excel -->
      <div class="upload-card excel"
           [class.active]="selectedType === 'excel'"
           (click)="!isUploading && selectType('excel')">
        <div class="type-inner">
          <div class="type-icon excel">X</div>
          <div class="type-text">
            <div class="type-title">Excel</div>
            <div class="type-subtitle">Select Excel Type</div>
          </div>
        </div>
      </div>

      <!-- JSON -->
      <div class="upload-card json"
           [class.active]="selectedType === 'json'"
           (click)="!isUploading && selectType('json')">
        <div class="type-inner">
          <div class="type-icon json">{{ '{' }} {{ '}' }}</div>
          <div class="type-text">
            <div class="type-title">JSON</div>
            <div class="type-subtitle">Select JSON Type</div>
          </div>
        </div>
      </div>

    </div>

    <!-- Only show selected -->
    <div class="selected-file" *ngIf="selectedType">
      <span class="file-badge">
        Selected: {{ selectedType | uppercase }}
      </span>
    </div>

    <!-- Optional Progress -->
    <div class="ship-progress" *ngIf="isUploading">
      <div class="progress-top">
        <div class="ship" [style.left.%]="progress">🚢</div>
      </div>

      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="progress"></div>
      </div>

      <div class="progress-label">
        Processing... {{ progress }}%
      </div>
    </div>

  </div>

  <div class="row">
    <button type="button" class="btn btn-light hover-clear clear"
            (click)="submit()"
            [disabled]="!selectedType || isUploading">
      <span>Submit</span>
    </button>
  </div>

</div>
